import {dataRegister} from "./dataRegister";

class blurRegister {

    static image = null;

    static create(url){
        dataRegister.createBlurImage({url: url}).then((response) => {
            blurRegister.set(response.data);
        }, (error) => {
            blurRegister.set(null);
        });
    }

    static set(value){
        blurRegister.image = value;
        try {
            sessionStorage.setItem("image-blur");
        }catch (e) {}
    }

    static get(){
        if(blurRegister.image){
            return blurRegister.image;
        }else{
            try {
                if(sessionStorage.getItem("image-blur")){
                    return sessionStorage.getItem("image-blur");
                }
            }catch (e) {}
        }
    }

    static remove(){
        blurRegister.image = null;
        try {
            sessionStorage.removeItem("image-blur");
        }catch (e) {}
    }

}

export {blurRegister}


// WEBPACK FOOTER //
// ./src/services/blurRegister.js